import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './adminlte.css';
import "./styles/kbola-nav.css";
import App from './App';
import reportWebVitals from './reportWebVitals';

import {Provider} from 'react-redux';
import store from './store/index';
import router from "./components/Router";
import {RouterProvider} from "react-router-dom";
import {LanguageProvider} from "./i18n/LanguageContext";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <LanguageProvider>
            <Provider store={store}>
                <RouterProvider router={router}>
                    <App/>
                </RouterProvider>
            </Provider>
        </LanguageProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
